import Carousel  from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {Row,Col,Container} from "react-bootstrap";
import meter1 from "../assets/img/react.png";
import meter2 from "../assets/img/flutter.png";
import meter3 from "../assets/img/js.png";
import meter4 from "../assets/img/sql.png";
import meter5 from "../assets/img/python.png";
import colorSharp from "../assets/img/color-sharp.png"
import { useEffect } from "react";

export const Skills =()=>
{



    const responsive = {
        superLargeDesktop: {
          
          breakpoint: { max: 4000, min: 3000 },
          items: 5
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };

      useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('view2');
            } else {
              entry.target.classList.remove('view2');
            }
          });
        });
    
        const hiddenElements = document.querySelectorAll('.show2');
        hiddenElements.forEach((el) => observer.observe(el));
    
       
        return () => {
          hiddenElements.forEach((el) => observer.unobserve(el));
        };
      }, []);

      return(
            <section className="skills" id="skill">

            <Container>
            <Row >
                <Col>
                <div className="skill-bx" >
                    <h2 className="show1">Skills</h2>
                    <p className="show1">Here are some of my skills</p>
                    <Carousel responsive={responsive} infinite={true} className="skill-slider show2">
                        <div className="item ">
                            <img src={meter1} alt="Image" className="skill-img"/>
                            <h5>React</h5>
                        </div>
                        <div className="item">
                            <img src={meter3} alt="Image" className="skill-img"/>
                            <h5>JavaScript</h5>
                        </div>
                        <div className="item">
                            <img src={meter2} alt="Image" className="skill-img"/>
                            <h5>Flutter</h5>
                        </div>
                       
                        <div className="item">
                            <img src={meter4} alt="Image" className="skill-img"/>
                            <h5>SQL</h5>
                        </div>
                        <div className="item">
                            <img src={meter5} alt="Image" className="skill-img"/>
                            <h5>Python</h5>
                        </div>
                    </Carousel>
                </div>

                </Col>
            </Row>
            </Container>

            {/* <img className="background-image-left" src={colorSharp}/> */}

            </section>
      )
}
